module.exports = __webpack_public_path__ + "assets/c0a764076c0a9ff3693f7e24c8158498.woff";